import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import {
  UpdateBreakageReport,
  UpdateBreakageReportParams,
} from "../../domain/usecases/update-breakage-report";
import { HttpClient } from "../protocols/http";

export class DbUpdateBrekageReport implements UpdateBreakageReport {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async update(params: UpdateBreakageReportParams): Promise<void> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "put",
      body: params,
    });

    if (res.statusCode > 199 && res.statusCode < 300) {
      return res.body;
    } else {
      if (res.statusCode === 401 || res.statusCode === 403) {
        throw new UnauthorizedError();
      }
      throw new Error(
        res.body.error.message ||
          res.body.error.data.message ||
          "Ocorreu um erro. Tente novamente em breve"
      );
    }
  }
}
